import { render, staticRenderFns } from "./FilterText.vue?vue&type=template&id=67f479a4&"
import script from "./FilterText.vue?vue&type=script&lang=js&"
export * from "./FilterText.vue?vue&type=script&lang=js&"
import style0 from "./FilterText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports